var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { FormProvider } from 'react-hook-form';
import { t } from '../../../../../../infra/i18n';
import { AddNewPromoCodeModal } from './add-new-promo-code-modal';
import { usePromoCodeForm } from './use-promo-code-form';
import { getDateFormat, getTimezone, getViewerIdAndKind, useSession } from '../../../../../../infra/session';
import { useApiMutation } from '../../../../../../infra/api';
import { showNotification } from '../../../../../../../app/common/helpers/notifications';
import { endpoints } from '../../../../network';
import { toApi } from '../../../../../../../app/main/settings/promoCodes/transformer';
import { useBreakpoints } from '../../../../../../infra/dls/hooks/use-get-breakpoints';
export var AddNewPromoCodeModalContainer = function (_a) {
    var open = _a.open, onClose = _a.onClose, onAfterSave = _a.onAfterSave;
    var session = useSession().data;
    var viewerIdAndKind = getViewerIdAndKind(session);
    var isMobileOrSmaller = useBreakpoints().isMobileOrSmaller;
    var form = usePromoCodeForm();
    var _b = useApiMutation({
        endpoint: endpoints.createPromoCodeMutation,
        options: {
            onSuccess: function (data) {
                showNotification({
                    title: t('engage:promo_code.created_title'),
                    message: t('engage:promo_code.created_message'),
                    autoDismiss: 8,
                });
                onAfterSave(data);
                onClose();
            },
        },
    }), createPromoCode = _b.mutate, isLoading = _b.isLoading;
    var selectedType = form.watch('kind');
    useEffect(function () {
        form.setValue('value', '');
    }, [selectedType, form.setValue, form]);
    useEffect(function () {
        form.reset();
    }, [open, form.reset, form]);
    var handleSave = function (data) {
        createPromoCode({
            ownerType: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.kind,
            ownerId: viewerIdAndKind === null || viewerIdAndKind === void 0 ? void 0 : viewerIdAndKind.id,
            promo: toApi(data, getTimezone(session), getDateFormat(session)),
        });
    };
    var handleSubmit = form.handleSubmit(function (data) {
        handleSave(data);
    });
    if (!open) {
        return null;
    }
    return (_jsx(FormProvider, __assign({}, form, { children: _jsx(AddNewPromoCodeModal, { onSubmit: handleSubmit, isMobileOrSmaller: isMobileOrSmaller, onClose: onClose, isLoading: isLoading }) })));
};
